// SiteUp: seções customizáveis do painel direito da conversa (ocultar/exibir,
// persistido em uiSettings.conversation_sidebar_hidden_items). Fonte única —
// usada pelo ContactPanel (customizador in-loco) e pela tela do Modo Foco.
// `label` fixo tem prioridade sobre `labelKey` (i18n), como em menuSections.js.
export const CONVERSATION_SIDEBAR_SECTIONS = [
  { name: 'kanban_panel', labelKey: 'SIDEBAR.FOCUS_MODE.ITEMS.KANBAN' },
  { name: 'jornada_360', labelKey: 'JORNADA_360.TITLE' },
  // SiteUp (Int-F4): dados públicos do WhatsApp (Waha::ContactEnrichmentJob)
  // + alerta de duplicata por LID. Só existe pra canais WAHA — o
  // v-else-if no ContactPanel gateia por isAWahaChannel.
  { name: 'waha_info', labelKey: 'SIDEBAR.FOCUS_MODE.ITEMS.WHATSAPP' },
  { name: 'tasks_panel', labelKey: 'SIDEBAR.FOCUS_MODE.ITEMS.TASKS' },
  { name: 'macros', labelKey: 'CONVERSATION_SIDEBAR.ACCORDION.MACROS' },
  {
    name: 'conversation_info',
    labelKey: 'CONVERSATION_SIDEBAR.ACCORDION.CONVERSATION_INFO',
  },
  { name: 'lead_origin', labelKey: 'SIDEBAR.FOCUS_MODE.ITEMS.LEAD' },
  {
    name: 'contact_attributes',
    labelKey: 'CONVERSATION_SIDEBAR.ACCORDION.CONTACT_ATTRIBUTES',
  },
  { name: 'lead_scoring', labelKey: 'SIDEBAR.FOCUS_MODE.ITEMS.LEAD_SCORE' },
  {
    name: 'contact_notes',
    labelKey: 'CONVERSATION_SIDEBAR.ACCORDION.CONTACT_NOTES',
  },
  { name: 'shared_files', labelKey: 'SIDEBAR.FOCUS_MODE.ITEMS.SHARED_FILES' },
  {
    name: 'previous_conversation',
    labelKey: 'CONVERSATION_SIDEBAR.ACCORDION.PREVIOUS_CONVERSATION',
  },
  {
    name: 'conversation_participants',
    labelKey: 'CONVERSATION_PARTICIPANTS.SIDEBAR_TITLE',
  },
  {
    name: 'linear_issues',
    labelKey: 'CONVERSATION_SIDEBAR.ACCORDION.LINEAR_ISSUES',
  },
  {
    name: 'shopify_orders',
    labelKey: 'CONVERSATION_SIDEBAR.ACCORDION.SHOPIFY_ORDERS',
  },
];
